/** Asset workflow API client (/api/assets/* → auth-server asset_workflow routes). */
async function call(path, { method = 'GET', body } = {}) {
  const res = await fetch(`/api/assets/${path}`, {
    method,
    credentials: 'include',
    headers: body ? { 'Content-Type': 'application/json' } : undefined,
    body: body ? JSON.stringify(body) : undefined,
  });
  let data = null;
  try {
    data = await res.json();
  } catch {
    /* empty body */
  }
  if (!res.ok) {
    const err = new Error(data?.detail ? String(typeof data.detail === 'string' ? data.detail : JSON.stringify(data.detail)) : `HTTP ${res.status}`);
    err.status = res.status;
    throw err;
  }
  return data;
}

export const fetchWorkflow = (dealId) => call(`${encodeURIComponent(dealId)}/workflow`);
export const fetchReviews = (dealId, asset) =>
  call(`${encodeURIComponent(dealId)}/reviews${asset ? `?asset=${encodeURIComponent(asset)}` : ''}`);
/** Deal-wide audit trail (all wells) for exports. */
export const fetchDealAudit = (dealId) =>
  call(`${encodeURIComponent(dealId)}/reviews?limit=5000`).then((d) => d.audit || []);
export const postReview = (dealId, assetId, body) =>
  call(`${encodeURIComponent(dealId)}/reviews/${encodeURIComponent(assetId)}`, { method: 'POST', body });
export const postFreeze = (dealId) => call(`${encodeURIComponent(dealId)}/freeze`, { method: 'POST' });
